import { VOUCHERS_ROUTES } from '../../constants/_routes'
import vouchersTypes from '../../constants/vouchersTypes'
import { axios } from '../../services'

//
const voucher_autofill_request = () => {
  return {
    type: vouchersTypes.autofill.request
  }
}

const voucher_autofill_success = (response) => {
  return {
    type: vouchersTypes.autofill.success,
    payload: response.data.results
  }
}

const voucher_autofill_failure = (messages) => {
  return {
    type: vouchersTypes.autofill.failure,
    payload: messages
  }
}

const voucher_autofill_clear = () => {
  return {
    type: vouchersTypes.autofill.clear
  }
}

const voucher_autofill = (input) => {
  return function (dispatch) {
    // Before Request
    dispatch(voucher_autofill_request())

    // Request
    axios.get(
      VOUCHERS_ROUTES.autofill,
      {params: {search: input}}
    ).then( response => {
      // success
      dispatch( voucher_autofill_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching user list."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( voucher_autofill_failure(errors))
    })
  }

}

export {
  voucher_autofill,
  voucher_autofill_clear
}



// WEBPACK FOOTER //
// ./src/js/actions/vouchers/autofill.js